import "./PendingChangesPanel.scss";
import { Header } from "../StickyTable";
import { RowType } from "./pendingChangesUtils";
import React from "react";

interface PendingDeletedRowProps<R> {
  columns: Header[];
  oldRow: R;
  pendingRowHeaderRender?: (row: R) => JSX.Element;
}

const PendingDeletedRow = <R extends RowType>({
  columns,
  oldRow,
  pendingRowHeaderRender,
}: PendingDeletedRowProps<R>): JSX.Element => {
  return (
    <div className="pendingChangesRowContainer pendingDeletedRowContainer">
      {pendingRowHeaderRender && (
        <div className="pendingChangesRowTitle">{pendingRowHeaderRender(oldRow)}</div>
      )}
      {columns.map(col => {
        const { label, field, renderer } = col;
        const oldVal = oldRow[field || ""] || "null";
        return (
          <div key={label}>
            <div className="pendingChangesRow">
              <b className="pendingChangesRowLabel">{label}:</b>
              <div>{renderer ? renderer(oldRow) : oldVal}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PendingDeletedRow;
